export default __webpack_public_path__ + "static/media/plaid-logo.7b082a36.svg";